function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export class OtpError extends Error {
  /**
   * Initializes a new instance of the OtpError class.
   *
   * @param {string} message - The error message.
   * @param {Object} [details={}] - Additional details related to the error.
   * @return {OtpError} A new OtpError instance.
   */
  constructor(message) {
    var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super(message);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "details", void 0);
    this.name = 'OtpError';
    this.details = details;
  }
}